import React from "react";
import { EventCard } from "components/eventCard/eventCard";
import { BreakfastShort } from "content-ui/breakfast/types";
import dynamic from "next/dynamic";

const EventRegistration = dynamic(
  () =>
    import(
      "content-ui/breakfast/components/upcomingEvent/eventRegistration/eventRegistration"
    ),
  {
    ssr: false,
  }
);

type UpcomingEventProps = {
  event: BreakfastShort;
  hasRsvped: (id: string) => boolean;
  isRsvpReady: boolean;
};

const UpcomingEvent = ({
  event,
  hasRsvped,
  isRsvpReady,
}: UpcomingEventProps) => {
  const heading = `In ${event.city} with ${event.moderators
    .map((el) => el.name)
    .join(", ")}`;

  return (
    <EventCard
      image={event.mainImage}
      heading={heading}
      title={event.title}
      timezone={event.timezone}
      registration={
        <EventRegistration
          event={event}
          hasRsvped={hasRsvped}
          isRsvpReady={isRsvpReady}
        />
      }
      eventDateTime={new Date(event.dateTime)}
      variant={"breakfast"}
      cardLink={`/breakfast/${event.slug}`}
      cardContainerClasses={"w-full min-h-[212px] lg:min-h-[242px]"}
      chevronClasses={"max-lg:px-4 max-lg:hidden"}
    />
  );
};

export default UpcomingEvent;
